export default __webpack_public_path__ + "static/media/our-process-three.9e39e50e.jpg";